import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M12 16a.82.82 0 0 1-.611-.273L5.7 9.327a.79.79 0 0 1 .076-1.129.82.82 0 0 1 1.147.075L12 13.985l5.076-5.712a.82.82 0 0 1 1.146-.075c.338.29.372.796.077 1.129l-5.687 6.4A.82.82 0 0 1 12 16",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-arrow-down"}) } }